import {
  ADD_ITEM_MENU,
  API_FETCH_MENU_SUCCESS,
  API_FETCH_MENU,
  API_FETCH_USER_SUCCESS,
  GENERATE_LOGIN_OTP_SUCCESS,
  LOGIN_GUEST_USER,
  REMOVE_ITEM_MENU,
  SEND_LOGIN_OTP_SUCCESS,
  CLEAR_REDIRECT,
  SET_SELECTED_CATEGORY,
  PLACE_ORDER_SUCCESS,
  CLEAR_CART,
  FETCH_REORDER_REQUEST,
  FETCH_REORDER_SUCCESS,
  ADD_TO_CART_FROM_REORDER,
  FETCH_BILL_REQUEST,
  FETCH_BILL_SUCCESS,
  SEND_WAITER_REQUEST_SUCCESS,
  SEND_WAITER_REQUEST,
  LOGOUT_SUCCESS,
  ADD_NOTE,
} from "./constant";
import menuList from "../sample-data/menu.json";
import { produce } from "immer";
import { fetchBillSuccess, generateOTPSuccess } from "./action";

const loadCartFromStorage = () => {
  try {
    const savedCart = localStorage.getItem("customer_cart");
    return savedCart ? JSON.parse(savedCart) : {};
  } catch (err) {
    return {};
  }
};

// 💾 Helper to sync draft cart to localStorage safely
const syncCartStorage = (cartObj) => {
  try {
    localStorage.setItem("customer_cart", JSON.stringify(cartObj));
  } catch (err) {
    console.error("Failed to save cart to localStorage:", err);
  }
};

// const initialState = { menu: {}, cart: {},generateOTP: null, guestUser: false, user: null, redirectTo: undefined | "MENU" | "REGISTER", order:[], reorder:[],
//  bill: [], waiterRequest:[]};

const initialState = {
  menu: {},
  cart: loadCartFromStorage(),
  generateOTP: null,
  guestUser: false,
  user: null,
  redirectTo: undefined | "MENU" | "REGISTER",
  order: [],
  reorder: [],
  bill: [],
  waiterRequest: [],
};

function reducers(state = initialState, action) {
  switch (action?.type) {
    case LOGOUT_SUCCESS:
      return {
        ...initialState, // Resets the state to original empty values
      };
    // case ADD_ITEM_MENU:

    //     return produce(state, draft => {

    //         if (draft.cart[action?.payload?.id]) {
    //             draft.cart[action?.payload?.id].selected+=1
    //         } else {
    //         const price = draft.menu.categories.find(cat => cat.categoryId === action?.payload?.selectedTab)
    //         .items.find(item => item.menuId === action?.payload?.id).price;
    //         const k = {
    //             id: action?.payload?.id,
    //             selectedTab: action?.payload?.selectedTab,
    //             price: price,
    //             selected: 1,
    //             note:action?.payload?.note ,
    //         }
    //         draft.cart[action?.payload?.id] = k
    //         }
    //     })
    // case REMOVE_ITEM_MENU:
    //     return produce(state, draft => {

    //         if (draft.cart[action?.payload?.id]?.selected === 1) {
    //             delete draft.cart[action?.payload?.id]
    //         } else {
    //             draft.cart[action?.payload?.id].selected-=1
    //         }
    //     })
    case ADD_ITEM_MENU:
      return produce(state, (draft) => {
        const itemId = action?.payload?.id;
        const variant = action?.payload?.variant;

        // Establish unique storage key identifier
        const cartKey = variant ? `${itemId}_${variant.sizeOptionId}` : itemId;

        if (draft.cart[cartKey]) {
          draft.cart[cartKey].selected += 1;
        } else {
          let price = 0;
          if (variant) {
            price = variant.price;
          } else {
            price = draft.menu.categories
              .find((cat) => cat.categoryId === action?.payload?.selectedTab)
              .items.find((item) => item.menuId === itemId).price;
          }

          const itemPayload = {
            id: itemId,
            cartKey: cartKey,
            selectedTab: action?.payload?.selectedTab,
            price: price,
            selected: 1,
            note: action?.payload?.note,
            variant: variant || null, // Store the selection properties cleanly
          };

          draft.cart[cartKey] = itemPayload;
        }
        syncCartStorage(draft.cart);
      });

    case REMOVE_ITEM_MENU:
      return produce(state, (draft) => {
        // Support clearing targets by standard string mapping identifiers or composed keys
        const cartKey = action?.payload?.cartKey || action?.payload?.id;

        if (draft.cart[cartKey]) {
          if (draft.cart[cartKey].selected === 1) {
            delete draft.cart[cartKey];
          } else {
            draft.cart[cartKey].selected -= 1;
          }
        }
        syncCartStorage(draft.cart);
      });
    case CLEAR_CART:
      localStorage.removeItem("customer_cart");
      return {
        ...state,
        cart: {}, // ✅ remove all items
      };

    case ADD_NOTE:
      return produce(state, (draft) => {
        const itemId = action?.payload?.cartKey || action?.payload?.id;
        const noteText = action?.payload?.note;
        console.log("noteText", noteText);
        // Check if the item exists in the cart first
        if (draft.cart[itemId]) {
          // ONLY update the note property, do NOT overwrite the whole object
          draft.cart[itemId].note = noteText;
        }
        syncCartStorage(draft.cart);
      });

    case API_FETCH_MENU_SUCCESS:
      return {
        ...state,
        menu: action?.payload,
      };
    case GENERATE_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        generateOTP: action.payload,
      };
    // case SEND_LOGIN_OTP_SUCCESS:
    //     return {
    //           ...state,
    //        user: action.payload.user || null,
    //        redirectTo: action.payload.redirectTo
    //     };
    case SEND_LOGIN_OTP_SUCCESS:
      // 1. Save user to localStorage so it survives a refresh
      console.log("calling  SEND_LOGIN_OTP_SUCCESS", action.payload);
      if (action.payload.user) {
        console.log("SEND_LOGIN_OTP_SUCCESS", action.payload.user);
        localStorage.setItem("user", JSON.stringify(action.payload.user));
      }
      //   else

      //   if (action.payload.redirectTo === "REGISTER") {
      //     console.log("SEND_LOGIN_OTP_SUCCESS")
      //        return {
      // ...state,
      // user: null,
      // redirectTo: action.payload.redirectTo,
      // guestUser: false
      // };
      //   }
      return {
        ...state,
        user: action.payload.user || null,
        redirectTo: action.payload.redirectTo,
        guestUser: false,
      };
    case CLEAR_REDIRECT:
      return {
        ...state,
        redirectTo: null,
      };
    case PLACE_ORDER_SUCCESS:
      console.log("PLACE_ORDER_SUCCESS", action.payload.redirectTo);
      console.log("PLACE_ORDER", action.payload.user);
      if (action.payload.user) {
        console.log("PLACE_ORDER_SUCCESS", action.payload.user);
      }
      return {
        ...state,
        //user: action?.payload.user || null,
        redirectTo: action.payload.redirectTo,
      };
    case SEND_WAITER_REQUEST_SUCCESS:
      return {
        ...state,
        waiterRequest: action?.payload,
        redirectTo: action.payload.redirectTo,
      };
    case API_FETCH_USER_SUCCESS:
      return {
        ...state,
        user: action?.payload,
        guestUser: false,
      };
    case LOGIN_GUEST_USER:
      return {
        ...state,
        guestUser: Boolean(action?.payload),
        user: null,
      };
    case SET_SELECTED_CATEGORY:
      return produce(state, (draft) => {
        draft.selectedCategory = action.payload;
      });
    case FETCH_REORDER_SUCCESS:
      return {
        ...state,
        reorder: action?.payload.reorder,
        redirectTo: action.payload.redirectTo,
        loading: false,
      };
    case FETCH_REORDER_REQUEST:
      return { ...state, loading: true };

    case FETCH_BILL_REQUEST:
      return { ...state, loading: true };
    // case ADD_TO_CART_FROM_REORDER: {
    //     const { menuId, price, qty, categoryId } = action.payload;
    //     const existing = state[menuId];
    //     const k = {
    //             id: menuId,
    //             selectedTab: categoryId,
    //             price: price,
    //             selected: existing ? existing.selected + qty   // ✅ MERGE
    //                 : qty
    //         }
    //    return produce(state, draft => {
    //            draft.cart[menuId] = k
    //     })
    // }

    case ADD_TO_CART_FROM_REORDER: {
      const { menuId, price, qty, categoryId, sizeOptionId, sizeName } =
        action.payload;

      // Unique storage key identifier setup
      const cartKey = sizeOptionId ? `${menuId}_${sizeOptionId}` : menuId;

      // Yahan state aur draft ko produce function ke andar wrap karna zaroori hai
      return produce(state, (draft) => {
        if (draft.cart[cartKey]) {
          draft.cart[cartKey].selected += qty;
        } else {
          const variantPayload = sizeOptionId
            ? {
                sizeOptionId: sizeOptionId,
                sizeName: sizeName,
                price: price,
              }
            : null;

          const itemPayload = {
            id: menuId,
            cartKey: cartKey, // 'isCartView' check ko activate karne ke liye
            selectedTab: categoryId,
            price: price, // Backend se aayi accurate variable price
            selected: qty, // Quantity map
            note: null,
            variant: variantPayload, // Exact object match MenuCard layout ke liye
          };

          draft.cart[cartKey] = itemPayload;
        }
        syncCartStorage(draft.cart);
      }); // Produce block context yahan close hoga
    }
    case FETCH_BILL_SUCCESS:
      return {
        ...state,
        bill: action?.payload,
        redirectTo: action.payload.redirectTo,
        loading: false,
      };

    default:
      return state;
  }
}

export default reducers;
